import { ReactNode, UIEvent, useEffect, useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Icon } from 'src/components';
import { TAccountCredentials, clearAccountCredentials, clearSignOut, signOutApi, useAppDispatch, useSignOutSelector } from 'src/store';
import { PATH_ACCOUNT, PATH_USER_CLIENT, PATH_USERS, PATH_USERS_TYPES, PERMISSIONS, PATH_SYSTEM_SETTINGS_TYPES, PATH_SYSTEM_SETTINGS, PATH_SYSTEM_SETTINGS_USERS, PATH_APPLICATION, PATH_BRAND, PATH_PROVIDER_BRAND, PATH_PROVIDER_USER, PATH_PRODUCT_SHORT, PATH_PRODUCT_FULL, PATH_PRODUCT_CART, PATH_PROVIDER, PATH_ACCOUNT_PRODUCT_SHORT, PATH_ACCOUNT_PRODUCT_CART, PATH_ACCOUNT_PROVIDER_USER, PATH_APPLICATION_USER_RELATION, PATH_ACCOUNT_CLIENT, PATH_ACCOUNT_PRODUCT_ORDER, PATH_PROVIDER_PARSER_FILE } from 'src/routes';
import { useIsMobile } from 'src/toolkit';

import { AsideItemList } from '../aside-item-list';
import { TAsideItem } from '../aside-item';

import navMenuStyles from '../NavMenu.module.scss';

import styles from './Aside.module.scss';


export const ASIDE_PORTAL_CONTAINER_ID = 'aside-menu-box';
export const ASIDE_SCROLL_CONTAINER_ID = 'aside-scroll-box';
export const ASIDE_MENU_ROW_CLASS_NAME = 'aside-menu-row-box';

type TAsideProps = {
	children?: ReactNode;
	style?: Record<string, string>;
	isVisible?: boolean;
	credentials: TAccountCredentials;
	onClick?: () => void;
};

function getMenu(): TAsideItem[][] {
	return [
		[
			{
				text: 'Аккаунт',
				icon: 'icon-gears',
				href: PATH_ACCOUNT,
				includes: [PATH_ACCOUNT],
			},
			// {
			// 	text: 'Паспортные данные',
			// 	icon: 'icon-user-tie',
			// 	href: PATH_ACCOUNT_PASSPORT,
			// 	includes: [PATH_ACCOUNT_PASSPORT],
			// 	permission: PERMISSIONS.ACCOUNT_PASSPORT,
			// },
			{
				text: 'Поиск',
				icon: 'icon-search',
				href: PATH_ACCOUNT_PRODUCT_SHORT,
				includes: [PATH_ACCOUNT_PRODUCT_SHORT],
				permission: PERMISSIONS.ACCOUNT_PRODUCT_SHORT,
			},
			{
				text: 'Заказы',
				icon: 'icon-cart',
				href: PATH_ACCOUNT_PRODUCT_ORDER,
				includes: [PATH_ACCOUNT_PRODUCT_ORDER],
				permission: PERMISSIONS.ACCOUNT_PRODUCT_CART,
			},
			{
				text: 'Корзина',
				icon: 'icon-cart',
				href: PATH_ACCOUNT_PRODUCT_CART,
				includes: [PATH_ACCOUNT_PRODUCT_CART],
				permission: PERMISSIONS.ACCOUNT_PRODUCT_CART,
			},
			{
				text: 'Поставщики',
				icon: 'icon-tree',
				href: PATH_ACCOUNT_PROVIDER_USER,
				includes: [PATH_ACCOUNT_PROVIDER_USER],
				permission: PERMISSIONS.ACCOUNT_PROVIDER_USER,
			},
			{
				text: 'Клиенты',
				icon: 'icon-addressbook',
				href: PATH_ACCOUNT_CLIENT,
				includes: [PATH_ACCOUNT_CLIENT],
				permission: PERMISSIONS.ACCOUNT_CLIENT,
			},

			// {
			// 	text: 'Заказы',
			// 	icon: 'icon-gears',
			// 	href: PATH_ACCOUNT_PASSPORT,
			// 	includes: [PATH_ACCOUNT_PASSPORT],
			// 	permission: PERMISSIONS.ACCOUNT_PASSPORT,
			// },
			// {
			// 	text: 'Настройки',
			// 	icon: 'icon-gears',
			// 	href: PATH_ACCOUNT_PASSPORT,
			// 	includes: [PATH_ACCOUNT_PASSPORT],
			// 	permission: PERMISSIONS.ACCOUNT_PASSPORT,
			// },
		],

		[
			{
				text: 'Поиск',
				icon: 'icon-search',
				href: PATH_PRODUCT_SHORT,
				includes: [PATH_PRODUCT_SHORT],
				permission: PERMISSIONS.RETRIEVE_PRODUCT_SHORT,
			},
			{
				text: 'Поиск Full',
				icon: 'icon-search',
				href: PATH_PRODUCT_FULL,
				includes: [PATH_PRODUCT_FULL],
				permission: PERMISSIONS.RETRIEVE_PRODUCT_FULL,
			},
			{
				text: 'Корзины',
				icon: 'icon-cart',
				href: PATH_PRODUCT_CART,
				includes: [PATH_PRODUCT_CART],
				permission: PERMISSIONS.RETRIEVE_PRODUCT_CART,
			},

			{
				text: 'Клиенты',
				icon: 'icon-addressbook',
				href: PATH_USER_CLIENT,
				includes: [PATH_USER_CLIENT],
				permission: PERMISSIONS.RETRIEVE_USER_CLIENT,
			},

			{
				text: 'Пользователи',
				icon: 'icon-users',
				href: PATH_USERS,
				includes: [PATH_USERS],
				permission: PERMISSIONS.RETRIEVE_USER,
			},
			{
				text: 'Типы пользователей',
				icon: 'icon-users',
				href: PATH_USERS_TYPES,
				includes: [PATH_USERS_TYPES],
				permission: PERMISSIONS.RETRIEVE_USER_TYPE,
			},

			{
				text: 'Приложения',
				icon: 'icon-apps',
				href: PATH_APPLICATION,
				includes: [PATH_APPLICATION],
				permission: PERMISSIONS.RETRIEVE_APPLICATION,
			},

			{
				text: 'Поставщики',
				icon: 'icon-tree',
				href: PATH_PROVIDER,
				includes: [PATH_PROVIDER],
				permission: PERMISSIONS.RETRIEVE_PROVIDER,
			},

			{
				text: 'Бренды',
				icon: 'icon-star-full',
				href: PATH_BRAND,
				includes: [PATH_BRAND],
				permission: PERMISSIONS.RETRIEVE_BRAND,
			},

			{
				text: 'Бренды поставщиков',
				icon: 'icon-star-empty',
				href: PATH_PROVIDER_BRAND,
				includes: [PATH_PROVIDER_BRAND],
				permission: PERMISSIONS.RETRIEVE_PROVIDER_BRAND,
			},

			{
				text: 'Пользователи поставщиков',
				icon: 'icon-briefcase',
				href: PATH_PROVIDER_USER,
				includes: [PATH_PROVIDER_USER],
				permission: PERMISSIONS.RETRIEVE_PROVIDER_USER,
			},

			{
				text: 'Файлы парсеров поставщиков',
				icon: 'icon-files-empty',
				href: PATH_PROVIDER_PARSER_FILE,
				includes: [PATH_PROVIDER_PARSER_FILE],
				permission: PERMISSIONS.RETRIEVE_SOURCE_PROVIDER_PARSER_FILE,
			},

			{
				text: 'Связи приложений и пользователей',
				icon: 'icon-keys',
				href: PATH_APPLICATION_USER_RELATION,
				includes: [PATH_APPLICATION_USER_RELATION],
				permission: PERMISSIONS.RETRIEVE_APPLICATION_USER_RELATION,
			},
		],

		[
			{
				text: 'Типы системных настроек',
				icon: 'icon-cogs',
				href: PATH_SYSTEM_SETTINGS_TYPES,
				includes: [PATH_SYSTEM_SETTINGS_TYPES],
				permission: PERMISSIONS.RETRIEVE_SYSTEM_SETTING_TYPE,
			},

			{
				text: 'Cистемные настройки',
				icon: 'icon-cog',
				href: PATH_SYSTEM_SETTINGS,
				includes: [PATH_SYSTEM_SETTINGS],
				permission: PERMISSIONS.RETRIEVE_SYSTEM_SETTING,
			},

			{
				text: 'Типы системных настроек',
				icon: 'icon-gear',
				href: PATH_SYSTEM_SETTINGS_USERS,
				includes: [PATH_SYSTEM_SETTINGS_USERS],
				permission: PERMISSIONS.RETRIEVE_SYSTEM_SETTING_TYPE,
			},
		],
	];
}

export function Aside(props: TAsideProps) {
	const dispatch = useAppDispatch();
	const { isTablet } = useIsMobile();
	const { isDone } = useSignOutSelector();
	const [scroll, setScroll] = useState(0);

	const {
		isVisible = false,
		style = {},
		credentials,
		onClick: hideAside = () => {},
	} = props;

	const { nickname: name = '', permissions, image = '' } = credentials;

	const onScroll = (e: UIEvent<HTMLDivElement, globalThis.UIEvent>) => {
		const elem = e.target;

		if (elem instanceof HTMLElement) {
			setScroll(elem.scrollTop);
		}
	}

	const onClick = () => {
		if (isTablet) {
			hideAside();
		}
	}

	const onLogout = () => {
		onClick();

		dispatch(signOutApi());
	};

	const menu = getMenu();

	useEffect(() => {
		if (isDone === true) {
			dispatch(clearAccountCredentials());
			dispatch(clearSignOut());
		}
	}, [isDone]);

	const protectedMenu = useMemo(() => {
		return menu.filter(item => {
			const links = item.filter(item => {
				const { permission: role } = item;

				return role ? permissions.includes(role) : true;
			});

			return links.length > 0;
		});
	}, [menu, credentials]);

	const classNames = [styles.aside, navMenuStyles.asideShow];

	if (isVisible) {
		classNames.push(styles.active);
	}

	const linkClassNames = [styles.asideLinkStyle, styles.avatarLink];
	const scrollListClassNames = ['scroll-box', styles.scrollList];

	return (
		<aside className={ classNames.join(' ') } style={ style }>
			<div className={ styles.asideRelativeBox }>
				<div className={ styles.header }>
					<div className={ styles.avatarWrapLink }>
						<NavLink
							className={ linkClassNames.join(' ') }
							to={ PATH_ACCOUNT }
							onClick={ onClick }
						>
							<span className={ styles.avatarWrap }>
								{ image && <img src={ image } className={ styles.avatarImage } alt="user_image" /> }
								{ !image && <span className={ styles.symbol }>{ name.slice(0, 1).toUpperCase() }</span> }
							</span>
							{ name }
						</NavLink>
					</div>
				</div>

				<div id={ ASIDE_PORTAL_CONTAINER_ID } className={ styles.portalContainer }></div>

				<div id={ ASIDE_SCROLL_CONTAINER_ID } className={ scrollListClassNames.join(' ') } onScroll={ onScroll }>
					{
						protectedMenu.map((items, index) => <AsideItemList key={ index } items={ items } onClick={ onClick } scroll={ scroll } />)
					}

					<div className={ styles.exit } onClick={ onLogout }>
						<span>
							<Icon icon="icon-exit" className={ styles.iconLink }/>
							Выход
						</span>
					</div>
				</div>
			</div>
		</aside>
	);
}
